import React, { useState, useCallback, useEffect } from 'react';
import { DebounceInput } from 'react-debounce-input';
import { useDispatch } from 'react-redux';
import onClickOutside from 'react-onclickoutside';
import classNames from 'classnames';
import { useList } from 'react-use';

import {
    getPlayers
} from './../../../actions/leader-board';
import { detectIconById } from '../../../common/enum';
import styles from '../../../components/dropdown/dropdown.module.css';

function KeywordSearch(props) {
    const [players, { set, push, removeAt }] = useList([]);
    const [suggestions, setSuggestions] = useState([]);
    const [toggle, setToggle] = useState(false);
    const [value, setValue] = useState('');
    const dispatch = useDispatch();

    useEffect(() => {
        if (players.length === 0) return;
        props.onChange(players)
    }, [players]);

    useEffect(() => {
        setValue('');
        set(props.players);
    }, [props.players]);

    const onSearch = useCallback(async (value) => {
        try {
            const result = await dispatch(getPlayers({
                keyword: value,
                teamIds: props.teamIds,
                startDate: props.startDate ? props.startDate.replace(/-/g, '') : null,
                endDate: props.endDate ? props.endDate.replace(/-/g, '') : null,
            }));
            setToggle(true);
            setSuggestions(result);
        } catch (e) {
            console.log(e);
        }
    }, [props]);

    const onAddPlayer = useCallback((player) => {
        if (players.find(item => item.id === player.id)) return;
        push(player);
        setToggle(false);
    }, [players]);

    const onRemoveAt = useCallback((index) => {
        if (players.length === 1) {
            props.onChange([]);
        }
        removeAt(index);
    }, [players]);

    KeywordSearch.handleClickOutside = useCallback(() => {
        setToggle(false);
    }, []);

    return <div className="search-input" style={{ position: 'relative' }}>
        <div className="option-bottom" style={{ alignItems: 'flex-start' }}>
            <div>
                <DebounceInput
                    value={value}
                    style={{ outline: 'none' }}
                    onFocus={(e) => {
                        if (!e.target.value) return;
                        onSearch(e.target.value);
                    }}
                    placeholder="選手選択"
                    minLength={2}
                    debounceTimeout={300}
                    onChange={e => {
                        setValue(e.target.value);
                        if (!e.target.value) return;
                        onSearch(e.target.value);
                    }} />
                <img alt='search' src='/img/action/ic_search_svg.svg' />
            </div>
            <div style={{ flexWrap: 'wrap' }}>
                {players.map((item, index) => {
                    return <div key={index} style={{ marginBottom: 5 }}>
                        <span>{item.player_name}</span>
                        <img alt="delete" src="/img/navigation/cancel_24px.svg" onClick={() => onRemoveAt(index)} />
                    </div>
                })}
            </div>
        </div>
        <div className={classNames(styles.blockSuggest, styles.dropdownMenu, toggle && styles.displayBlock)}>
            {suggestions.map((suggestion, index) => {
                return <div onClick={() => onAddPlayer(suggestion)} className={styles.dropdownMenuItem} key={index}>
                    <div>
                        <img style={{ width: 20, marginRight: 10 }}
                            src={detectIconById(suggestion.team.id)} alt="team-name" />
                        {suggestion.player_name}
                        <span style={{
                            color: '#74818A',
                            fontSize: 13,
                            marginLeft: 10
                        }}>{suggestion.uniform_number}</span>
                    </div>
                    <span className="fa fa-search form-control-feedback" />
                </div>
            })}
        </div>
    </div>
}

const clickOutsideConfig = {
    handleClickOutside: () => KeywordSearch.handleClickOutside
};

export default onClickOutside(KeywordSearch, clickOutsideConfig);

